import { useTranslation } from 'react-i18next'
import Stepper from '@mui/material/Stepper'
import Step from '@mui/material/Step'
import StepButton from '@mui/material/StepButton'

import { StepOption, stepArrangement, useSelectionContext } from '../context/SelectionContext'
import Box from '@mui/material/Box'

export const StepContainer: React.FC = ({ children }) => {
  const { t } = useTranslation()
  const { activeIndex, currentStep, setStep, typeSelectMode } = useSelectionContext()

  const onStepClick = (complete: boolean, step: StepOption) => {
    if (complete) {
      setStep(step)
    }
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', minHeight: 0 }}>
      {currentStep !== StepOption.DONE && (
        <Stepper activeStep={activeIndex} sx={{ pb: 3, pt: 1 }}>
          {stepArrangement
            .filter(step => step !== StepOption.DONE && !(step === StepOption.CONFIRM && typeSelectMode))
            .map((label, index) => (
              <Step key={label} completed={index < activeIndex}>
                <StepButton
                  color='inherit'
                  onClick={() => {
                    onStepClick(index < activeIndex, label)
                  }}
                  sx={{ p: 1, m: theme => `-${theme.spacing(1)}` }}
                >
                  {t(`unknown_vehicle.${label}`)}
                </StepButton>
              </Step>
            ))}
        </Stepper>
      )}
      {children}
    </Box>
  )
}
